export const STACKING = Object.freeze({
  header: 40,
  dropdown: 50,
  popover: 60,
  modal: 100,
  toast: 200,
});
